import { render, staticRenderFns } from "./OAuth2.vue?vue&type=template&id=b85855ea&scoped=true"
import script from "./OAuth2.vue?vue&type=script&lang=js"
export * from "./OAuth2.vue?vue&type=script&lang=js"
import style0 from "./OAuth2.vue?vue&type=style&index=0&id=b85855ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85855ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b85855ea')) {
      api.createRecord('b85855ea', component.options)
    } else {
      api.reload('b85855ea', component.options)
    }
    module.hot.accept("./OAuth2.vue?vue&type=template&id=b85855ea&scoped=true", function () {
      api.rerender('b85855ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OAuth2.vue"
export default component.exports